<div *ngIf="!isLoading" class="page-norights">
  <h1 class="landing">{{ 'norights.title' | transloco }}</h1>

  <ng-container *ngIf="!isLoading">

    <ng-container *ngIf="isDetached; else notDetached">
      <ng-container [ngTemplateOutlet]="isDetached"></ng-container>
    </ng-container>

    <ng-template #notDetached>
      <ng-container *ngIf="!!userInfo?.trusted && !userInfo?.roleId; else notConfirmed">
        <ng-container [ngTemplateOutlet]="noRoles"></ng-container>
      </ng-container>
    </ng-template>

    <ng-template #notConfirmed>
      <ng-container [ngTemplateOutlet]="notConfirmed"></ng-container>
    </ng-template>

  </ng-container>

  <!-- Подтвержденный пользователь, но нет ролей -->
  <ng-template #noRoles>
    <h5>{{ 'norights.input4user' | transloco }}</h5>
    <div class="text">
      <p class="translate mb-0">{{ 'norights.text1' | transloco }}</p>
      <p class="translate mb-0">{{ 'norights.text2' | transloco }}</p>
    </div>
    <h5>{{ 'norights.input5user' | transloco }}</h5>
    <div class="text">
      <p class="mb-0 translate">{{ 'norights.text3' | transloco }}</p>
      <h5>{{ 'norights.input6user' | transloco }}</h5>
      <div class="d-flex" *ngIf="!!norightsInstructionHref">
        <svg-icon key="document" class="me-3"></svg-icon>
        <a
          [attr.data-test]="'norights_link-instrukciya-gis-ehpd'"
          class="w-100 link translate text-decoration-none"
          href="{{ norightsInstructionHref }}"
          >{{ 'norights.textLink' | transloco }}</a
        >
      </div>
    </div>
  </ng-template>


  <!-- У пользователя не подтверждены почта/телефон -->
  <ng-template #notConfirmed>
    <h5>{{ 'dearUser' | transloco }}!</h5>
    <p *ngIf="accountStatus === AccountStatusEnum.AwaitingConfirmationController" class="translate desc">
      {{ 'norights.awaitingConfirmationController' | transloco }}
    </p>
    <p *ngIf="accountStatus === AccountStatusEnum.ConfirmationCanceled" class="translate desc">{{ 'norights.confirmationCanceled' | transloco }}</p>
    <p *ngIf="accountStatus === AccountStatusEnum.FinalConfirmationDenied" class="translate desc">{{ 'norights.finalConfirmationDenied' | transloco }}</p>
    <p *ngIf="accountStatus === AccountStatusEnum.AccountDeleted" class="translate desc">{{ 'norights.accountDeleted' | transloco }}</p>

    <ng-container
      *ngIf="
        (!isMailConfirmed || !isPhoneConfirmed) &&
        accountStatus !== AccountStatusEnum.AwaitingConfirmationController &&
        accountStatus !== AccountStatusEnum.ConfirmationCanceled &&
        accountStatus !== AccountStatusEnum.FinalConfirmationDenied &&
        accountStatus !== AccountStatusEnum.AccountDeleted
      "
    >
      <p class="translate desc">{{ 'norights.not_confirm_title' | transloco }}</p>
      <ul>
        <li *ngIf="!isPhoneConfirmed" class="translate desc mb-2">{{ 'norights.not_confirm_phone' | transloco }}</li>
        <li *ngIf="!isMailConfirmed" class="translate desc">{{ 'norights.not_confirm_email' | transloco }}</li>
      </ul>
    </ng-container>
    <p class="translate desc">{{ 'norights.not_confirm_footer' | transloco }}</p>
    <h5 *ngIf="accountStatus === AccountStatusEnum.AwaitingConfirmationController">{{ 'norights.input7user' | transloco }}</h5>
  </ng-template>

  <ng-template #isDetached>
    <h5>{{ 'dearUser' | transloco }}!</h5>
    <p class="translate desc">{{ 'norights.detachedText1' | transloco }}</p>
    <p class="translate desc">{{ 'norights.detachedText2' | transloco }}</p>
    <p class="translate desc">{{ 'norights.detachedText3' | transloco }}</p>
    <p class="translate desc">{{ 'norights.detachedText4' | transloco }}</p>
  </ng-template>

  <app-contacts-info></app-contacts-info>

  <button
    class="primary xl w-100 mt-3 logout-btn"
    disableRipple
    [routerLink]="['/profile']"
    data-test="norights_btn-logout"
  >
    {{ 'go_profile' | transloco }}
  </button>
</div>

<div *ngIf="isLoading" class="page-norights bg-transparent w-100">
  <mat-spinner [diameter]="100" class="mt-5 m-auto"></mat-spinner>
</div>
